export const CONTACT = {
  name: "Ranjan Danta",
  email: "info@balangirgroup.com",
  phone: "+91 99443 58914",
  phoneHref: "tel:+919944358914",
  whatsapp: "919944358914",
  telegram: "https://t.me/balangirgroupp",
  address: "13/335A, Sakthi Nagar, West Ingur, Erode, Tamil Nadu - 638052",
  city: "Erode, Tamil Nadu",
};
